import React from 'react';
import classNames from 'classnames';
const SearchResult = ({ isOpen, children }) => (<div className={classNames('dropdown-menu', 'dropdown-menu--search', {
        show: isOpen,
    })} aria-hidden={!isOpen} data-placement="bottom-start">
        {children}
    </div>);
export default SearchResult;
